import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {}

const MedalStarIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			width="73"
			height="73"
			viewBox="0 0 73 73"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M57.7917 27.3747C57.7917 31.7851 56.4838 35.8306 54.233 39.2068C50.948 44.0735 45.7467 47.5105 39.6938 48.3926C38.6596 48.5751 37.595 48.6663 36.5 48.6663C35.405 48.6663 34.3405 48.5751 33.3063 48.3926C27.2534 47.5105 22.0521 44.0735 18.7671 39.2068C16.5163 35.8306 15.2084 31.7851 15.2084 27.3747C15.2084 15.6034 24.7288 6.08301 36.5 6.08301C48.2713 6.08301 57.7917 15.6034 57.7917 27.3747Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M64.6354 56.1794L59.6167 57.3656C58.4913 57.6394 57.6092 58.4911 57.3659 59.6165L56.3013 64.0878C55.7234 66.5211 52.6209 67.2511 51.0088 65.3349L36.5 48.6665L21.9913 65.3652C20.3792 67.2815 17.2767 66.5514 16.6988 64.1181L15.6342 59.6469C15.3605 58.5214 14.4784 57.6394 13.3834 57.3961L8.36462 56.2099C6.05295 55.6624 5.2317 52.7727 6.90462 51.0998L18.7671 39.2373C22.0521 44.104 27.2534 47.5411 33.3063 48.4232C34.3405 48.6057 35.405 48.6969 36.5 48.6969C37.595 48.6969 38.6596 48.6057 39.6938 48.4232C45.7467 47.5411 50.948 44.104 54.233 39.2373L66.0954 51.0998C67.7684 52.7423 66.9471 55.6319 64.6354 56.1794Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M38.2641 18.1895L40.0587 21.7786C40.302 22.2653 40.9408 22.752 41.5187 22.8432L44.7733 23.3907C46.8416 23.7253 47.3283 25.2462 45.8379 26.7366L43.3133 29.2611C42.8875 29.6869 42.6441 30.5082 42.7962 31.1166L43.5262 34.2495C44.1041 36.7132 42.7962 37.6865 40.6062 36.3786L37.5645 34.584C37.017 34.2494 36.1045 34.2494 35.557 34.584L32.5154 36.3786C30.3254 37.6561 29.0175 36.7132 29.5954 34.2495L30.3254 31.1166C30.447 30.5387 30.2341 29.6869 29.8083 29.2611L27.2837 26.7366C25.7933 25.2462 26.28 23.7557 28.3483 23.3907L31.6029 22.8432C32.1504 22.752 32.7891 22.2653 33.0325 21.7786L34.827 18.1895C35.7091 16.2428 37.2908 16.2428 38.2641 18.1895Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default memo(MedalStarIcon);
